/** Mathematical lookup values derived from trigonometric functions. */
export const SCALED_SINES: number[] = Array.from({ length: 90 }, (_, degree) =>
  Math.round(Math.sin((degree * Math.PI) / 180) * 128),
);
export const ANGLE_GRID: number[][] = Array.from({ length: 10 }, (_, row) =>
  Array.from({ length: 10 }, (_cell, column) =>
    Math.round((Math.atan2(row + 1, column + 1) * 180) / Math.PI),
  ),
);
export const FRAME_HEADINGS: number[] = Array.from({ length: 32 }, (_, frame) =>
  Math.floor(((frame < 16 ? 270 + frame * 22.5 : 90 - (frame - 16) * 22.5) + 360) % 360),
);
export const FRAME_DEG = 22.5;
export const ANGLE_EPS = 22;
